import React from 'react';
import { ModelMapEditor } from '@leverege/ui-plugin';
import { Pane, TabPane } from '@leverege/ui-elements';
import { ns } from '@leverege/i18n';
import useDetailTabLabel from '../shared/useDetailTabLabel.js';
import Model from './ItemModel.js';
import OptionsEditor from "./OptionsEditor.js";
import ItemTypeRenderer from "./ItemTypeRenderer.js";
import S from './ItemEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.detail.item.ItemEditor');
const editorHints = {
  placementHandled: true
};
function ItemEditor(props) {
  const {
    value,
    eventData,
    onChange,
    allowCollapseToOne = true,
    showDisplayOptions = true,
    filter,
    isSubEditor
  } = props;
  if (value == null) {
    return /*#__PURE__*/_jsx(Pane, {
      variant: "padding",
      children: t('noModel')
    });
  }
  const forward = e => {
    onChange({
      value: e.value,
      data: eventData
    });
  };
  const tabLabel = useDetailTabLabel({
    allowCollapseToOne,
    value,
    filter,
    model: Model
  });
  if (!showDisplayOptions) {
    return /*#__PURE__*/_jsx(ModelMapEditor, {
      allowCollapseToOne: allowCollapseToOne,
      filter: filter,
      value: value,
      listClassName: S.list,
      selectionHeader: header,
      rendererIsRemovable: false,
      renderer: ItemTypeRenderer,
      model: Model.types(),
      selectionProps: {
        ...editorHints,
        ...props
      },
      propKeyForSelected: "objectType",
      onChange: forward
    });
  }
  return /*#__PURE__*/_jsxs(TabPane, {
    className: S.editor,
    children: [/*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: tabLabel,
      tabId: "types",
      children: /*#__PURE__*/_jsx(ModelMapEditor, {
        allowCollapseToOne: allowCollapseToOne,
        filter: filter,
        value: value,
        listClassName: S.list,
        selectionHeader: header,
        rendererIsRemovable: false,
        renderer: ItemTypeRenderer,
        model: Model.types(),
        selectionProps: {
          ...editorHints,
          ...props
        },
        propKeyForSelected: "objectType",
        onChange: forward
      })
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabName: t('options'),
      tabId: "options",
      children: /*#__PURE__*/_jsx(OptionsEditor, {
        isSubEditor: isSubEditor,
        value: value,
        onChange: forward
      })
    })]
  });
}
function header(item, key) {
  return null;
  // if ( item ) {
  //   return <Text variant="subtitle">{item.name||key}</Text>
  // }
  // return <Text variant="subtitle">-</Text>
}
export default /*#__PURE__*/React.memo(ItemEditor);